export default __webpack_public_path__ + "static/cues-starters-light-463e7066a8873f3c1e06155fdfdb4494c195735362a4d4a6cb64fce9266012fc.png";